









































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class DatePicker extends Vue {
  @Prop() label?: string;

  @Prop() value!: any;

  @Prop() rules!: any;

  @Prop({ type: Boolean, default: false }) clearable!: boolean;

  beforeUpdate() {
    this.selectedDate(this.value);
  }

  selectedDate(value: Date) {
    this.$emit('input', value);
  }
}
